import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Navbar from "../../nav_bar/Navbar";
import Footer from "../../footer/Footer";
import { fetchIpaLessonById } from "./ipaService";
import "./IpaPage.css";

const difficultyColor = (d) => {
  const map = { BEGINNER: "#4caf50", INTERMEDIATE: "#ff9800", ADVANCED: "#e91e63" };
  return map[d?.toUpperCase()] || "#999";
};

const IpaLessonDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [lesson, setLesson] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      const res = await fetchIpaLessonById(id);
      if (res.status === 200 && res.data?.status) {
        setLesson(res.data.data);
      }
      setLoading(false);
    };
    load();
  }, [id]);

  if (loading) {
    return (<><Navbar /><div className="ipa-detail"><p className="ipa-detail-loading">Loading...</p></div><Footer /></>);
  }

  if (!lesson) {
    return (
      <><Navbar />
        <div className="ipa-detail">
          <p className="ipa-detail-not-found">Lesson not found.</p>
          <button className="ipa-back" onClick={() => navigate("/study/ipa/lessons")}>← Back to Lessons</button>
        </div>
      <Footer /></>
    );
  }

  return (
    <>
      <Navbar />
      <div className="ipa-detail">
        <button className="ipa-back" onClick={() => navigate("/study/ipa/lessons")}>← Back to Lessons</button>

        <div style={{ marginBottom: 24 }}>
          <h1 style={{ margin: "0 0 6px", fontSize: "1.8rem", color: "#222" }}>{lesson.title}</h1>
          <span className="ipa-difficulty-badge" style={{ background: difficultyColor(lesson.difficulty) }}>
            {lesson.difficulty}
          </span>
        </div>

        {lesson.description && (
          <div className="ipa-card">
            <h3 className="ipa-card-title">📝 About this Lesson</h3>
            <p className="ipa-card-text">{lesson.description}</p>
          </div>
        )}

        {lesson.symbols?.length > 0 && (
          <div className="ipa-card">
            <h3 className="ipa-card-title">🔤 Sounds in this Lesson ({lesson.symbols.length})</h3>
            <div className="ipa-lesson-symbols">
              {lesson.symbols.map((s) => (
                <div key={s.id} className="ipa-lesson-symbol-card" onClick={() => navigate(`/study/ipa/symbols/${s.id}`)}>
                  <div className="ipa-symbol-char">{s.symbol}</div>
                  <div className="ipa-symbol-example">{s.exampleWord}</div>
                  <div className="ipa-symbol-ipa">{s.exampleIpa}</div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default IpaLessonDetailPage;
